import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box, Text } from '@chakra-ui/react';
import { useSemanticTypography } from '@whitbread-eos/utils';
import { jsx as _jsx } from "react/jsx-runtime";
export default function FormError(_ref) {
  var _errors$name;
  var errors = _ref.errors,
    name = _ref.name,
    extraStyles = _ref.extraStyles;
  var getTypographyProps = useSemanticTypography();
  if (errors !== null && errors !== void 0 && (_errors$name = errors[name]) !== null && _errors$name !== void 0 && (_errors$name = _errors$name.message) !== null && _errors$name !== void 0 && _errors$name.length) {
    var _errors$name2;
    var errorTypographyProps = getTypographyProps({
      fontSize: 'xs'
    }, {
      textStyle: 'body-s-regular'
    });
    var textStyles = _objectSpread(_objectSpread({}, errorTypographyProps), {}, {
      color: 'error',
      marginLeft: 'md',
      marginTop: 'sm',
      whiteSpace: 'nowrap'
    });
    return _jsx(Box, _objectSpread(_objectSpread({}, _objectSpread(_objectSpread({}, formErrorStyles), extraStyles === null || extraStyles === void 0 ? void 0 : extraStyles.containerStyle)), {}, {
      children: _jsx(Box, _objectSpread(_objectSpread({}, errorMessageStyles), {}, {
        children: _jsx(Text, _objectSpread(_objectSpread({}, _objectSpread(_objectSpread({}, textStyles), extraStyles === null || extraStyles === void 0 ? void 0 : extraStyles.textStyle)), {}, {
          children: errors === null || errors === void 0 || (_errors$name2 = errors[name]) === null || _errors$name2 === void 0 ? void 0 : _errors$name2.message
        }))
      }))
    }));
  }
  return null;
}
var formErrorStyles = {
  height: 'var(--chakra-space-lg)',
  position: 'relative'
};
var errorMessageStyles = {
  position: 'absolute'
};